// Shared option lists for selects and GeneralStatusLabel.
export const doctorStatuses = [
  { value: 1, label: "Active", statusColor: "mint-green" },
  { value: 0, label: "Inactive", statusColor: "red" },
];
export const variationStatuses = [
  { value: "active", label: "Active", statusColor: "mint-green" },
  { value: "inactive", label: "Inactive", statusColor: "gray" },
];
export const packageStatuses = [
  { value: "published", label: "Published", statusColor: "mint-green" },
  { value: "draft", label: "Draft", statusColor: "yellow-light" },
  { value: "archived", label: "Archived", statusColor: "gray" },
];
export const bookingStatuses = [
  { value: "pending", label: "Pending", statusColor: "yellow-orange" },
  { value: "confirmed", label: "Confirmed", statusColor: "blue" },
  { value: "cancelled", label: "Cancelled", statusColor: "gray" },
  { value: "completed", label: "Completed", statusColor: "mint-green" },
];
export const packageVisibilityStatuses = packageStatuses.map(status => ({
  ...status,
  label: status.value === "published" ? "Active"
    : status.value === "archived" ? "Inactive" : status.label,
}));
export const packageTypes = [
  { value: "package", label: "Package", statusColor: "blue" },
  { value: "promotion", label: "Promotion", statusColor: "yellow-orange" },
  { value: "informative", label: "Informative", statusColor: "blue" },
  { value: "privilege", label: "Privilege", statusColor: "cyan" },
];
export const profileTeamMemberVerificationStatus = [
  { value: 0, label: "You", statusColor: "blue" },
  { value: 1, label: "Verified", statusColor: "mint-green" },
  { value: 2, label: "Unverified", statusColor: "yellow-orange" },
];

export const packageEditorTypes = packageTypes.map(item => item.value === "informative"
  ? { ...item, label: "Promotion", statusColor: "yellow-orange" }
  : item);

export const registrationFieldStatuses = [
  { value: "required", label: "Required", statusColor: "gray" },
];

// Numeric API values also match string values (0 and "0"). Never treat 0 as empty.
export function getStatusDefinition(value, list = []) {
  const valid = typeof value === "string" || typeof value === "number";
  const key = valid ? String(value).trim().toLowerCase() : null;
  const option = key === null ? undefined : list?.find(item => String(item.value).trim().toLowerCase() === key);
  return option || { value, label: valid && key !== "" ? String(value) : "-", statusColor: "gray" };
}

const Helpers = {
  doctorStatuses, variationStatuses, packageStatuses, packageVisibilityStatuses,
  bookingStatuses, packageTypes, packageEditorTypes, registrationFieldStatuses,
  profileTeamMemberVerificationStatus,
};
export default Helpers;
